define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/Applicant", "../entity/Permit", "../../utils/MathUtil", "../domain", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, Applicant_1, Permit_1, MathUtil_1, domain_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitApplication = void 0;
    class PermitApplication extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Description", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DescriptionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantSearchIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantSearchIndexError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalFeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalFeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTotalFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTotalFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTotalFeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTotalFeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceInsurer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceInsurerError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsurancePolicyNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsurancePolicyNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceEndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceEndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceAmount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceAmountError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceIsCertProv", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InsuranceIsCertProvError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Applicant", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedApplicant", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NO_DROVER_ID", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PermitApplication.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.Applicant = [];
            this.Permit = [];
        }
        onRead(entity, parent) {
            this.Applicant = [];
            this.Permit = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.Description = b.Description;
            a.ApplicantSearchIndex = b.ApplicantSearchIndex;
            a.TotalFee = (0, EntityUtil_1.toFloat)(entity.TotalFee);
            a.TotalFeeStateGov = (0, EntityUtil_1.toFloat)(entity.TotalFeeStateGov);
            a.FinalTotalFee = (0, EntityUtil_1.toFloat)(entity.FinalTotalFee);
            a.FinalTotalFeeStateGov = (0, EntityUtil_1.toFloat)(entity.FinalTotalFeeStateGov);
            a.InsuranceInsurer = b.InsuranceInsurer;
            a.InsurancePolicyNo = b.InsurancePolicyNo;
            a.InsuranceEndDt = b.InsuranceEndDt;
            a.InsuranceAmount = (0, EntityUtil_1.toFloat)(entity.InsuranceAmount);
            a.InsuranceIsCertProv = (0, EntityUtil_1.toInt)(entity.InsuranceIsCertProv);
            a.Applicant = this.mergeArray(a.Applicant, b.Applicant, Applicant_1.Applicant);
            a.SelectedApplicant = a.SelectedApplicant && a.Applicant.find(x => x.Id == a.SelectedApplicant.Id) ? a.SelectedApplicant : null;
            a.Permit = this.mergeArray(a.Permit, b.Permit, Permit_1.Permit);
            a.SelectedPermit = a.SelectedPermit && a.Permit.find(x => x.Id == a.SelectedPermit.Id) ? a.SelectedPermit : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.SelectedApplicant = this.Applicant.length > 0 ? this.Applicant[0] : undefined;
            this.SelectedPermit = this.Permit.length > 0
                ? this.ActivePermits.length > 0
                    ? this.ActivePermits[0]
                    : this.Permit[0]
                : undefined;
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PermitApplication.AliasName);
            this.reset();
            if (!this.HasDraftPermits) {
                this._validate(validationState, false);
                if (isNaN(this.InsuranceIsCertProv) || this.InsuranceIsCertProv == -1) {
                    this.InsuranceIsCertProvError = "Was a Certificate of Currency Provided?";
                    validationState.addError(this.InsuranceIsCertProvError);
                }
                if (isNaN(this.InsuranceAmount) || this.InsuranceAmount < 1) {
                    this.InsuranceAmountError = "Insurance Amount is required";
                    validationState.addError(this.InsuranceAmountError);
                }
                if (this.Applicant.length > 0) {
                    var hasApplicant = false;
                    var hasOwner = false;
                    var hasDrover = false;
                    for (let applicant of this.Applicant) {
                        if (applicant.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                            for (let role of applicant.ApplicantRole) {
                                if (role.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                                    hasOwner = hasOwner || (role.ApplicantType == domain_1.ApplicantTypeDomain.Owner);
                                    hasApplicant = hasApplicant || (role.ApplicantType == domain_1.ApplicantTypeDomain.Applicant);
                                    hasDrover = hasDrover || (role.ApplicantType == domain_1.ApplicantTypeDomain.Drover);
                                }
                            }
                            validationState.add(applicant.validate());
                        }
                    }
                    if (this.ApplicationPermitType == domain_1.PermitTypeDomain.TravelPermit) {
                        if (!hasOwner) {
                            validationState.addError("An Applicant with a role of 'Owner' must be specified");
                        }
                        if (!hasApplicant) {
                            validationState.addError("An Applicant with a role of 'Applicant' must be specified");
                        }
                    }
                    else {
                        if (!hasApplicant) {
                            validationState.addError("An Applicant with a role of 'Applicant' must be specified");
                        }
                    }
                }
                else {
                    validationState.addError("At least one Applicant must be specified");
                }
            }
            for (let child of this.Permit) {
                validationState.add(child.validate());
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqString(validationState, "InsuranceInsurer", "Insurer Name");
                this.validateReqString(validationState, "InsurancePolicyNo", "Insurance Policy Number");
                this.validateReqDate(validationState, "InsuranceEndDt", "Insurance End Date");
                this.validateReqNumber(validationState, "InsuranceAmount", "Insurance Amount", { precision: 2 });
                this.validateReqNumber(validationState, "InsuranceIsCertProv", "Certificate of Currency Provided?");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.Applicant) {
                for (let x of this.Applicant) {
                    x.walk(func, { leading });
                }
            }
            if (this.Permit) {
                for (let x of this.Permit) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                Description: this.Description,
                ApplicantSearchIndex: this.ApplicantSearchIndex,
                TotalFee: this.TotalFee,
                TotalFeeStateGov: this.TotalFeeStateGov,
                FinalTotalFee: this.FinalTotalFee,
                FinalTotalFeeStateGov: this.FinalTotalFeeStateGov,
                InsuranceInsurer: this.InsuranceInsurer,
                InsurancePolicyNo: this.InsurancePolicyNo,
                InsuranceEndDt: this.InsuranceEndDt,
                InsuranceAmount: this.InsuranceAmount,
                InsuranceIsCertProv: this.InsuranceIsCertProv,
                Applicant: this.Applicant.map(x => x.toJson()),
                Permit: this.Permit.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ActivePermits() {
            return this.Permit.filter(p => p.SystemState == domain_1.EntitySysStatusDomain.Active);
        }
        get HasDraftPermits() {
            return this.Permit.find(p => p.License.ActiveLicenseStatus == domain_1.PermitLicenseStatusDomain.Draft) != null;
        }
        get PermitSrnIds() {
            var srnIds = [];
            for (let p of this.ActivePermits) {
                if (p.SrnSegments) {
                    for (let srnId of p.SrnSegments.split(",")) {
                        srnIds.push(srnId);
                    }
                }
            }
            return srnIds.join(",");
        }
        get DroverApplicants() {
            let drovers = new domain_1.DynamicDomain();
            for (let a of this.Applicant.filter(a => a.IsDrover)) {
                drovers.addByKv(a.Id, a.Name);
            }
            drovers.addByKv(this.NO_DROVER_ID, "None");
            return drovers;
        }
        calculatePermitFees() {
            if (this.ActivePermits) {
                this.TotalFee = (0, MathUtil_1.round)(this.ActivePermits.reduce((prev, p) => {
                    return prev += (p.FeeTotal || 0);
                }, 0), 2);
                this.TotalFeeStateGov = (0, MathUtil_1.round)(this.ActivePermits.reduce((prev, current) => {
                    return prev += (current.FeeStateGov || 0);
                }, 0), 2);
            }
        }
        get ApplicationPermitType() {
            if (this.Permit.length > 0) {
                return this.Permit[0].PermitType;
            }
            else {
                throw new Error("Unable to derive Application Permit Type");
            }
        }
        amend() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Amending Permit");
                services_1.SrmsServiceManager.Instance.PermitApplication.createPermitAmendment(this.toJson(), this.SelectedPermit.Id).then(res => {
                    (0, EventManager_1.notify)("Amendment Complete");
                    this.merge(res.Application);
                    this.SelectedPermit = this.Permit.find(p => p.Id == res.NewPermitId);
                    this.IncludeHistory = true;
                    resolve();
                });
            });
        }
        injectUnfitStockTravelPermitIntoApplication(ufsStartPoint, ufsTravelDays, isRouteSplitRequested) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Unfit Stock Permit");
                services_1.SrmsServiceManager.Instance.PermitApplication.createUnfitStockTravelPermit(this.toJson(), ufsStartPoint, ufsTravelDays, isRouteSplitRequested).then(res => {
                    (0, EventManager_1.notify)("Create Complete");
                    this.merge(res.Application);
                    this.SelectedPermit = this.Permit.find(p => p.Id == res.UfsPermitId);
                    resolve();
                });
            });
        }
        injectUnfitStockGrazingPermitIntoApplication(ufsStartPoint, ufsTravelDays, isRouteSplitRequested) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Unfit Stock Permit");
                services_1.SrmsServiceManager.Instance.PermitApplication.createUnfitStockGrazingPermit(this.toJson(), ufsStartPoint, ufsTravelDays, isRouteSplitRequested).then(res => {
                    (0, EventManager_1.notify)("Create Complete");
                    this.merge(res.Application);
                    this.SelectedPermit = this.Permit.find(p => p.Id == res.UfsPermitId);
                    resolve();
                });
            });
        }
    }
    exports.PermitApplication = PermitApplication;
    Object.defineProperty(PermitApplication, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PermitApplication"
    });
    Object.defineProperty(PermitApplication, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit Application"
    });
    Object.defineProperty(PermitApplication, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId", "Description", "ApplicantSearchIndex", "TotalFee", "TotalFeeStateGov", "FinalTotalFee", "FinalTotalFeeStateGov", "InsuranceInsurer", "InsurancePolicyNo", "InsuranceEndDt", "InsuranceAmount", "InsuranceIsCertProv"]
    });
    Object.defineProperty(PermitApplication, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(PermitApplication, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "DescriptionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1024
    });
    Object.defineProperty(PermitApplication, "DescriptionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Give a brief description of the proposed permit. For Travel Permits, enter a description of the route being taken (start point, end point, and stock routes and any roads traversed). For Grazing Permits, enter a brief description of the grazing area being requested"
    });
    Object.defineProperty(PermitApplication, "DescriptionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "ApplicantSearchIndexLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PermitApplication, "ApplicantSearchIndexReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "TotalFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "TotalFeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "FinalTotalFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "FinalTotalFeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitApplication, "InsuranceInsurerLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PermitApplication, "InsuranceInsurerReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitApplication, "InsurancePolicyNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(PermitApplication, "InsurancePolicyNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitApplication, "InsuranceEndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitApplication, "InsuranceAmountReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitApplication, "InsuranceIsCertProvTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Has a copy of the Certificate of Currency been provided?"
    });
    Object.defineProperty(PermitApplication, "InsuranceIsCertProvReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "Description", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "DescriptionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "ApplicantSearchIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "ApplicantSearchIndexError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "TotalFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "TotalFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "TotalFeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "TotalFeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "FinalTotalFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "FinalTotalFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "FinalTotalFeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "FinalTotalFeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceInsurer", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceInsurerError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsurancePolicyNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsurancePolicyNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceEndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceEndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceAmount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceAmountError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceIsCertProv", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "InsuranceIsCertProvError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "Applicant", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "SelectedApplicant", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "ApplicantError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "SelectedPermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "PermitError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitApplication.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitApplication.prototype, "IncludeHistory", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], PermitApplication.prototype, "ActivePermits", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PermitApplication.prototype, "HasDraftPermits", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PermitApplication.prototype, "PermitSrnIds", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PermitApplication.prototype, "DroverApplicants", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitApplication.prototype, "calculatePermitFees", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitApplication.prototype, "amend", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitApplication.prototype, "injectUnfitStockTravelPermitIntoApplication", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitApplication.prototype, "injectUnfitStockGrazingPermitIntoApplication", null);
});
